<template>
  <template v-if="isInit">
    <basic-layout v-if="layout == 'basic'"/>
    <main-layout v-if="layout == 'main'"/>
    <blank-layout v-if="layout == 'blank'"/>
  </template>
  <loading :is-active="$loading.is"/>
</template>

<script setup>
import BasicLayout from "@/layouts/basic/basic-layout.vue";
import MainLayout from "@/layouts/main/main-layout.vue";
import BlankLayout from "@/layouts/blank/blank-layout.vue";

import {computed, onMounted, ref} from "vue";
import {getStore, getUtils} from "@/utils/import";
const {$loading, $day, $mber} = getStore();
const {$router, $axios, $file} = getUtils();

let isInit = ref(false);

const layout = computed(() => {
  return $router.currentRoute.value.meta.layout;
});

const setDay = async () => {
  const {data} = await $axios.get('/api/cmmn/day');
  $day.set(data);
}

onMounted(async () => {
  const {data: mber} = await $axios.get('/api/cmmn/mber-session');

  if (mber && mber.mberSn != null && mber.role == 'ROLE_USER') {
    const params = {mberSn: mber.mberSn};
    const {data} = await $axios.get('/api/mber/by-mber-sn', {params});
    const mberInfo = data;
    $mber.set({mberSn: mberInfo.mberSn, mberNm: mberInfo.mberNm});
  } else {
    $mber.clear();
  }

  await Promise.all([
      setDay(),
      $file.ncp.cmmn.createAllBucket(),
  ]);

  isInit.value = true;
})
</script>

<style>
@import '@/assets/css/seroi.css';
@import '@/assets/css/smartaib4pc-certui.css';
</style>
